var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.672 3.673-1.078 1.078a.292.292 0 0 1-.211.094.223.223 0 0 1-.188-.094L8.594 2.15a.223.223 0 0 1-.094-.188c0-.078.031-.148.094-.21L9.672.672c.219-.218.484-.328.797-.328.312 0 .578.11.797.328l1.406 1.407c.219.218.328.484.328.796 0 .313-.11.579-.328.797ZM7.656 2.69l-6.14 6.14L1 11.69a.538.538 0 0 0 .164.492c.14.14.305.196.492.164l2.86-.515 6.14-6.141a.291.291 0 0 0 .094-.211.223.223 0 0 0-.094-.187L8.055 2.689a.223.223 0 0 0-.188-.094.291.291 0 0 0-.21.094Zm-4.593 7.594h1.124v.844l-1.5.28-.75-.75.282-1.5h.844v1.126Z",
    fill: "#D7D2CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.2c8b088f761ddce4157f280796ae7824.svg";
export { ForwardRef as ReactComponent };